// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import styles from "../../styles/ProfileScreenStyle";
import { fetchUserData } from "../../axios/axiosConfig";
import logger from "../../axios/loggingConfig";
const ProfileScreen = ({ getTranslation }) => {
    const [userData, setUserData] = useState(null);

    const fetchData = async () => {
        try {
            const response = await fetchUserData("Farmer");
            if (response.status === 200) {
                setUserData(response.data.company);
            }
        } catch (error) {
            logger.error("Error in fetchUserData(Farmer): " + error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <ScrollView contentContainerStyle={styles.container}>
            {userData ? (
                <View style={styles.dataContainer}>
                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>
                                {getTranslation("Denominazione Sociale")}
                            </Text>
                            <Text style={styles.value}>{userData.companyName}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Via")}</Text>
                            <Text style={styles.value}>{userData.address.street}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Cap")}</Text>
                            <Text style={styles.value}>{userData.address.zipCode}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Località")}</Text>
                            <Text style={styles.value}>{userData.address.locality}</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Comune")}</Text>
                            <Text style={styles.value}>{userData.address.city}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("P.IVA")}</Text>
                            <Text style={styles.value}>{userData.vatNumber || "-"}</Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>
                                {getTranslation("Codice Fiscale")}
                            </Text>
                            <Text style={styles.value}>{userData.codiceFiscale}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>
                                {getTranslation("Contatti di Riferimento")}
                            </Text>
                            <Text style={styles.value}>
                                {userData.appContact.title} {userData.appContact.firstName}{" "}
                                {userData.appContact.lastName}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Telefono")}</Text>
                            <Text style={styles.value}>{userData.appContact.phone}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>{getTranslation("Email")}</Text>
                            <Text style={styles.value}>{userData.appContact.email}</Text>
                        </View>
                    </View>
                </View>
            ) : (
                <Text style={styles.label}>
                    {getTranslation("Carimento del profilo attendere...")}
                </Text>
            )}
        </ScrollView>
    );
};

export default ProfileScreen;
